import styled, { css } from 'styled-components';
import FinalCtaBackground from '../assets/images/final-cta-background.webp';
import socialGlow from '../assets/images/social-glow.webp';
import integrationGlow from '../assets/images/integration-glow-cropped.webp';

import Logos from '../components/organisms/logos';

export const HomeWrapper = styled.div`
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.charcoal};
`;

export const HeroWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.charcoal};
`;

export const LightSandWrapper = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.lightSand};
`;

export const GradientBackgroundsWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    background-color: ${theme.colors.charcoal};
    background-image: url(${socialGlow}), url(${integrationGlow});
    background-position: center bottom 240px, top left;
    background-size: 800px, 60vw;
    background-repeat: no-repeat;

    ${theme.screenSize.s768.mediaQuery} {
      background-position: center bottom 10px, top left;
      background-size: 1020px, 60vw;
    }
  `}
`;

export const AudienceFinalCtaWrapper = styled.div`
    background-image: url(${FinalCtaBackground});
    background-position: bottom;
    background-size: cover;
    background-repeat: no-repeat;
`;

export const HomepageLogos = styled(Logos)``;
